/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantHealthSkippedEmail
 */
export interface TenantHealthSkippedEmail {
    /**
     * 
     * @type {string}
     * @memberof TenantHealthSkippedEmail
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantHealthSkippedEmail
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantHealthSkippedEmail
     */
    from?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantHealthSkippedEmail
     */
    to?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TenantHealthSkippedEmail
     */
    subject?: string;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthSkippedEmail
     */
    date?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthSkippedEmail
     */
    last_modified?: number;
}

/**
 * Check if a given object implements the TenantHealthSkippedEmail interface.
 */
export function instanceOfTenantHealthSkippedEmail(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantHealthSkippedEmailFromJSON(json: any): TenantHealthSkippedEmail {
    return TenantHealthSkippedEmailFromJSONTyped(json, false);
}

export function TenantHealthSkippedEmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantHealthSkippedEmail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'last_modified': !exists(json, 'last_modified') ? undefined : json['last_modified'],
    };
}

export function TenantHealthSkippedEmailToJSON(value?: TenantHealthSkippedEmail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'reason': value.reason,
        'from': value.from,
        'to': value.to,
        'subject': value.subject,
        'date': value.date,
        'last_modified': value.last_modified,
    };
}

